import {
  FIXED,
  MOBILE,
  EXPEDITED_MOBILE,
  NORMAL_MOBILE,
  RISK_LEVEL_3,
  RISK_LEVEL_4,
} from 'AppSrc/core/components/forms/value-dependency-constants';

const mobileApprovalCommSLA = {
  [MOBILE]: {
    [NORMAL_MOBILE]: {
      [RISK_LEVEL_3]: 5,
      [RISK_LEVEL_4]: 5,
    },
    [EXPEDITED_MOBILE]: {
      [RISK_LEVEL_3]: 2,
      [RISK_LEVEL_4]: 2,
    },
  },
  [FIXED]: {},
};

export { mobileApprovalCommSLA };
